module.exports = __webpack_public_path__ + "static/media/notification-important.7882b051.svg";